import {useEffect} from "react";
import useAuth from "@/hooks/auth.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import {useNavigate} from "react-router-dom";
import Button from "@/ui/Button.tsx";
import {useTranslation} from "react-i18next";
import IDCardIcon from "@/svg/IDCardIcon.tsx";


const KYCWaitingScreen = () => {
    const auth = useAuth()
    const user = auth.current_user()
    const navigate = useNavigate()
    const {t} = useTranslation()
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    useEffect(() => {
        let interval = setInterval(async () => {
            if(debug === "true") console.info("interval KYCWaitingScreen")
            await auth.small_update();
        }, 5000)
        
        return () => {
            clearInterval(interval)
        }
        
    }, []);
    
    useEffect(() => {
        
        if(user?.kyc.identity_card === "ProcessingSuccess" && user?.kyc.liveness === "Unknown") {
            navigate(DashboardClass.dashboard_routes.KYC + "/2")
            
        } else if(user?.kyc_general_status === "ProcessingFailed" || user?.kyc_general_status === "ProcessingFailedAndSentToManager") {
            navigate(DashboardClass.dashboard_routes.Home)
            
        } else if(user?.kyc_general_status === "ProcessingSuccess") {
            
            navigate(DashboardClass.dashboard_routes.SuccessKYC)
        }
    }, [user]);
    
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh"
            }}
        >
            <IDCardIcon />
            
            <strong
                style={{
                    maxWidth:"300px",
                    fontSize: "24px",
                    textAlign: "center",
                    fontWeight: "700"
                }}
            >
                {t("processing_kyc")}
            </strong>
            
            <Button
                onClick={() =>{
                    navigate(DashboardClass.dashboard_routes.Home)
                }}
            >
                {t("back")}
            </Button>
        </div>
    )
}

export default KYCWaitingScreen